import React from 'react';
import '../css/Spinner.css';

interface SpinnerProps {
  color: string,
  centerVertical: boolean
}

function Spinner({ color, centerVertical }: SpinnerProps) {
  let classes = "lds-ring";
  if (centerVertical) {
    classes = classes + " spinnerCenterVertical";
  }

  return (
    <div className={classes}>
      <div style={{ borderTopColor: color }}></div>
      <div style={{ borderTopColor: color }}></div>
      <div style={{ borderTopColor: color }}></div>
      <div style={{ borderTopColor: color }}></div>
    </div>
  );
}

export default Spinner;
